export enum Version {
  VX = 'vX', // This version is used as "unknown" (in the case of external sales)
  V1 = 'v1',
  V2 = 'v2',
}
